module.exports = __webpack_public_path__ + "static/media/cdb7.bd582339.png";